import { render } from "./index.vue?vue&type=template&id=ecede2d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ecede2d0&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecede2d0"],['__file',"src/views/chess/order/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecede2d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecede2d0', __exports__)) {
    console.log('reload')
    api.reload('ecede2d0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ecede2d0&scoped=true", () => {
    console.log('re-render')
    api.rerender('ecede2d0', render)
  })

}


export default __exports__